import PropTypes from "prop-types"
import { Helmet } from "react-helmet-async"

import Divider from "components/ui/divider"
import Media from "components/ui/media"
import Picture from "components/ui/picture"

import {
  AuthenticateContent,
  AuthenticateModalTitle,
  Footnote,
} from "./components"
import RegisterForm from "./register-form"

const Register = ({ setModalContent }) => {
  const content = (
    <AuthenticateContent>
      <Media greaterThanOrEqual="tablet">
        <Picture
          alt=""
          className="base:w-(--base-width) desktop:w-(--desktop-width)"
          fallback={require("images/account/register_modal_desktop.jpg")}
          srcSet={[
            {
              height: "701",
              media: "(max-width: 1023px)",
              srcSet: `
                ${require("images/account/register_modal_tablet.jpg")} 283w,
                ${require("images/account/register_modal_tablet_2x.jpg")} 566w
              `,
              width: "283",
            },
            {
              height: "580",
              media: "(min-width: 1024px)",
              srcSet: `
                ${require("images/account/register_modal_desktop.jpg")} 482w,
                ${require("images/account/register_modal_desktop_2x.jpg")} 964w
              `,
              width: "482",
            },
          ]}
          style={{
            "--base-width": "283px",
            "--desktop-width": "482px",
          }}
        />
      </Media>
      <div className="max-w-375 tablet:max-w-none tablet:px-16 desktop:px-24 m-auto w-full px-24">
        <AuthenticateModalTitle>Create A VIP Account</AuthenticateModalTitle>
        <RegisterForm setModalContent={setModalContent} />
        <Divider className="bg-grey-30 my-24 w-1/2" />
        <Footnote>
          Note: Creating an account is not required to purchase from{" "}
          {sl.config.site_title}.
        </Footnote>
      </div>
    </AuthenticateContent>
  )
  if (setModalContent) {
    return content
  } else {
    return (
      <div className="contained mb-64">
        <Helmet>
          <title>Signup</title>
        </Helmet>
        <div className="desktop:max-w-855 tablet:max-w-640 mx-auto my-24">
          {content}
        </div>
      </div>
    )
  }
}

Register.propTypes = {
  setModalContent: PropTypes.func,
}

export default Register
